<template>
    <Layout>
    <PageHeader :title="title" :items="items" />
    
    <div class="row mb-4">
        <div class="col-lg-12 col-sm-126">
            <div class="card h-100 ">
            <div class="card-body text-left">
                <div class="row ">
                  <div class="col-sm-6">
                        <h5>{{ $t('instagram.preview') }}</h5>  
                  </div>
                  <div class="col-sm-6 text-right text-secondary">
                        <button role="button"  class="btn btn-success btn-sm w-md ml-1" @click="generateReport">
                            <i class="fa fa-file-pdf mr-1" v-if="!generate"></i>
                            <i class="bx bx-loader-alt bx-spin mr-1" v-if="generate"></i>
                             Download PDF
                    </button>  
                  </div>
              </div>
               
            </div>
            </div>
        </div>
    </div>
    
    <simplebar style="max-height: 70vh;">
        <vue-html2pdf
                :show-layout="true"
                :float-layout="false"
                :enable-download="enableDownload"
                :preview-modal="previewModal"
                :paginate-elements-by-height="1900"
                :filename="filename"
                :pdf-quality="2"
                :manual-pagination="true"
                pdf-format="letter"
                pdf-orientation="portrait"
                pdf-content-width="800px"
                ref="html2Pdf"
                >
                <section slot="pdf-content">
                    
                        <!-- Person details & sentiment -->
                        <div class="row mb-2">
                        <div class="col-lg-12 col-sm-12">
                            <div class="card h-100 ">
                            <div class="card-body text-left">
                                <div class="text-center justify-content-between">
                                    <h2><img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" class="mb-1" /> </h2> <h4 class="mt-1"><b>{{ $t('instagram.laporan') }}</b></h4>
                                    <hr>
                                </div>
                                <div class="row pt-3">
                                    <div class="col-sm-6">
                                        <h5>{{ $t('instagram.basic-info') }}</h5>  
                                    </div>
                                    <div class="col-sm-6 text-right text-secondary">
                                        <span class="text-secondary btn btn-sm btn-light mr-1 mb-1">{{ $t('instagram.updated') }}: {{formatDateRefresh(basicInfo.updated_at)}}</span> 
                                    </div>
                                </div>
                                <div class="mb-3 mt-4">
                                    <div class="media">
                                          <img
                                                :src="avatar+basicInfo.avatar"
                                                class="mr-3 rounded-circle avatar-xl"
                                                alt="user-pic" v-if="basicInfo.avatar"
                                                />
                                            <img
                                                src="https://img.icons8.com/ios/240/000000/user-male-circle.png"
                                                class="mr-3 rounded-circle avatar-xl"
                                                alt="user-pic" v-else
                                                />
                                        <div class="media-body p-1 text-center">
                                        <h6 class="mb-1 text-uppercase">{{ $t('instagram.followers') }}</h6>
                                        <hr>
                                        <h6 >{{basicInfo.followers}}</h6>
                                        </div>
                                        <div class="media-body p-1 text-center">
                                        <h6 class="mb-1 text-uppercase">{{ $t('instagram.following') }}</h6>
                                        <hr>
                                        <h6>{{basicInfo.following}} </h6>
                                        </div>
                                        <div class="media-body p-1 text-center">
                                        <h6 class="mb-1  text-uppercase">{{ $t('instagram.post') }}</h6>
                                        <hr>
                                        <h6>{{basicInfo.media}} </h6>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                        <a :href="'https://www.instagram.com/'+basicInfo.username" target="_blank" class="d-flex mb-2">
                                            <span class="text-primary my-auto">{{basicInfo.name}}</span> 
                                            <span v-if="basicInfo.is_verified == 1"><i class="my-auto ml-1 text-primary mdi mdi-check-decagram mdi-18px"></i></span>
                                        </a>
                                        <p class="text-secondary mb-3">  @{{basicInfo.username}} </p>
                                        <span v-if="basicInfo.is_private == 1" class="text-secondary d-flex align-items-center"> <i class="text-dark mdi mdi-shield-lock-outline mdi-24px"></i>  {{ $t('instagram.this') }} </span>
                                        <div v-if="basicInfo.category_name">
                                            <h6 class="mt-2">{{ $t('instagram.category') }}</h6>
                                            <p>{{basicInfo.category_name}}</p>
                                        </div>
                                        <h6 class="mt-2">Bio</h6>
                                        <p>{{basicInfo.bio}}</p>
                                </div>

                                 <table class="table table-bordered py-2 mb-3 mt-4">
                                    <thead>
                                     <h5 class="pt-5 text-center">{{ $t('twitter.twitter-view.sentimen') }}</h5>
                                    </thead>
                                    <tbody >
                                        <tr class="p-4">
                                            <div v-if="!sentimenOptions.series">
                                                <center><h6 class="py-5 text-secondary mt-5 pt-5">{{ $t('overview.table.all.dnf') }}</h6></center> 
                                            </div>
                                            <div class="text-center p-3" v-if="sentimenOptions.series">
                                             <apexchart
                                                class="apex-charts"
                                                dir="ltr"
                                                height="340"
                                                :series="sentimenOptions.series"
                                                :options="sentimenOptions.chartOptions"
                                            ></apexchart>
                                            </div>
                                        </tr>
                                    </tbody>
                                </table> 
                            </div>
                            </div>
                        </div>
                        </div>
                        
                        <!-- Word Cloud -->
                        <div class="html2pdf__page-break"/>
                        <div class="row mb-4">
                        <div class="col-lg-12 col-sm-12">
                            <div class="card h-100 ">
                            <div class="card-body text-left">
                                   <table class="table table-bordered py-2">
                                    <thead>
                                    <h5 class="p-3">{{ $t('twitter.twitter-view.word-cloud') }}</h5>
                                    </thead>
                                    <tbody >
                                         <tr class="p-4">
                                         <div v-if="wordCloud == ''">
                                                <center><h6 class="py-5 text-secondary mt-5 pt-5">{{ $t('overview.table.all.dnf') }}</h6></center> 
                                            </div>
                                            <div class="text-center p-5" v-if="wordCloud">
                                            <vue-word-cloud
                                                style="
                                                height: 480px;
                                                margin-left:3%;

                                                width: 95%;?
                                                font-family: arial, sans-serif;
                                            "
                                            :words="wordCloud"
                                            :color="([, weight]) =>
                                                    weight > 10
                                                    ? '#BD241E'
                                                    : weight > 5
                                                    ? '#bc0505'
                                                    : '#d10404'"
                                            font-family="Poppins, sans-serif"
                                            />
                                            </div>
                                            </tr>
                                    </tbody>
                                    </table>     
                            </div>
                            </div>
                        </div>
                        </div>

                           <!-- Heatmap post by time -->
                        <div class="row mt-4">
                            <div class="col-lg-12 col-sm-12">
                                    <div class="card">
                                        <div class="row">
                                        <div class="col-sm-6">
                                                <h5 class="p-4">{{ $t('instagram.heat-map') }}</h5>
                                        </div>
                                        <div class="col-sm-6 text-right px-4 pt-4">
                                            <!-- <span class="text-secondary btn btn-sm btn-light mr-1" v-if="created_at_heatmap">{{ $t('twitter.updated') }} {{formatDateRefresh(created_at_heatmap)}}</span>  -->
                                        </div>
                                    </div>
                                    <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loadingheatmap">
                                            <div class="text-center loading mb-3">
                                                <b-spinner label="Loading..."></b-spinner>
                                            </div>
                                    </div>
                                    <div class="col-sm-12 p-5 mt-5 mb-5" v-if="!loadingheatmap && !cek_heatmap">
                                    <div class="text-center loading mb-3">
                                        {{$t('all.dnf')}}
                                    </div>
                                    </div>
                                    <div class="p-4" v-if="!loadingheatmap && cek_heatmap">
                                        <apexchart type="heatmap" height="350" :options="{
                                        chart: {
                                            height: 350,
                                            type: 'heatmap',
                                        },
                                        dataLabels: {
                                            enabled: false
                                        },
                                        colors: ['#bf151c'],
                                        theme: {
                                            mode: theme, 
                                            palette: 'palette1', 
                                            monochrome: {
                                                enabled: false,
                                                color: '#bf151c',
                                                shadeTo: theme,
                                                shadeIntensity: 0.7
                                            },
                                        },
                                        title: {
                                            text: this.$t('instagram.last-heat-map'),
                                            align: 'center'
                                        },
                                    }" :series="heatmapSeries"></apexchart>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- usertag tweets  -->
                        <div class="html2pdf__page-break"/>
                        <div class="row mt-4 mb-4">
                            <div class="col-lg-12 col-sm-12">
                                <div class="card">
                                    <div>
                                        <h5 class="pt-4 px-4">{{ $t('instagram.recent-post') }} ({{ $t('instagram.last-post') }})</h5>
                                    </div>
                                    <div class="card-body">
                                    <div class="table-responsive mb-0">
                                            <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th width="20%">{{$t('instagram.date-time')}}</th>
                                                    <th width="50%">{{$t('instagram.accessibility_caption')}}</th>
                                                    <th class="text-center" width="15%">{{$t('instagram.likes')}}</th>
                                                    <th class="text-center" width="15%">{{$t('instagram.comments')}}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(ig, index) in tableData" :key="index"  style="page-break-inside: avoid;">
                                                    <td width="20%">  
                                                    <span class="text-secondary">{{formatDay(ig.taken_at)}} <br>{{formatDate(ig.taken_at)}}</span>
                                                    </td>
                                                    <td width="50%">{{ig.caption_text}}</td>
                                                    <td class="text-center"  width="15%">{{ig.like_count}}</td>
                                                    <td class="text-center"  width="15%">{{ig.comment_count}}</td>
                                                </tr>
                                            </tbody>
                                            </table>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                           
                         <!-- timeline tweets  -->
                        <div class="html2pdf__page-break"/>
                        <div class="row mt-4 mb-4">
                            <div class="col-lg-12 col-sm-12">
                                <div class="card">
                                    <div>
                                        <h5 class="pt-4 px-4">{{ $t('instagram.user-tags') }}  ({{ $t('instagram.last-tags') }})</h5>
                                    </div>
                                    <div class="card-body">
                                    <div class="table-responsive mb-0">
                                            <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th width="20%">{{$t('instagram.date-time')}}</th>
                                                    <th width="60%">{{$t('instagram.accessibility_caption')}}</th>
                                                    <th class="text-center" width="10%">{{$t('instagram.likes')}}</th>
                                                    <th class="text-center" width="10%">{{$t('instagram.comments')}}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(ig, index) in tableDataTags" :key="index"  style="page-break-inside: avoid;">
                                                    <td>  
                                                    <span class="text-secondary">{{formatDay(ig.taken_at)}} <br>{{formatDate(ig.taken_at)}} <br>
                                                   </span>
                                                    <span class="text-primary">({{ig.screen_name}})</span>
                                                    </td>
                                                    
                                                    <td width="60%">{{ig.caption_text}}</td>
                                                    <td class="text-center">{{ig.like_count}}</td>
                                                    <td class="text-center">{{ig.comment_count}}</td>
                                                </tr>
                                            </tbody>
                                            </table>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- similiar tweets  -->
                        <div class="html2pdf__page-break"/>
                        <div class="row mt-4 mb-4">
                            <div class="col-lg-12 col-sm-12">
                                <div class="card">
                                    <div>
                                        <h5 class="pt-4 px-4">{{ $t('instagram.similiar-account') }}</h5>
                                    </div>
                                    <div class="card-body">
                                    <div class="table-responsive mb-0">
                                            <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th width="4%" class="text-center">No</th>
                                                    <th width="40%">{{$t('instagram.account')}}</th>
                                                    <th width="46%">{{$t('instagram.full_name')}}</th>
                                                    <th class="text-center" width="10%">Verified</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(ig, index) in tableDataSimiliar" :key="index"  style="page-break-inside: avoid;">
                                                    <td class="text-center">{{index+1}}</td>
                                                    <td class="text-left">{{ig.username}}</td>
                                                    <td class="text-left">{{ig.full_name}}</td>
                                                    <td class="text-center">
                                                        <span v-if="ig.is_verified" class="text-secondary"> <i class="my-auto ml-1 text-primary mdi mdi-check-decagram mdi-18px"></i> </span>
                                                        <span v-else class="text-secondary"> - </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            </table>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- last followers tweets  -->
                        <div class="html2pdf__page-break"/>
                        <div class="row mt-4 mb-4">
                            <div class="col-lg-12 col-sm-12">
                                <div class="card">
                                    <div>
                                        <h5 class="pt-4 px-4">{{ $t('instagram.last-followers') }}</h5>
                                    </div>
                                    <div class="card-body">
                                    <div class="table-responsive mb-0">
                                            <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th width="4%" class="text-center">No</th>
                                                    <th width="40%">{{$t('instagram.account')}}</th>
                                                    <th width="46%">{{$t('instagram.full_name')}}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(ig, index) in tableDataFollowers" :key="index"  style="page-break-inside: avoid;">
                                                    <td class="text-center">{{index+1}}</td>
                                                    <td class="text-left">{{ig.username}}</td>
                                                    <td class="text-left">{{ig.full_name}}</td>
                                                </tr>
                                            </tbody>
                                            </table>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                          <!-- last following tweets  -->
                        <div class="html2pdf__page-break"/>
                        <div class="row mt-4 mb-4">
                            <div class="col-lg-12 col-sm-12">
                                <div class="card">
                                    <div>
                                        <h5 class="pt-4 px-4">{{ $t('instagram.last-following') }}</h5>
                                    </div>
                                    <div class="card-body">
                                    <div class="table-responsive mb-0">
                                            <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th width="4%" class="text-center">No</th>
                                                    <th width="40%">{{$t('instagram.account')}}</th>
                                                    <th width="46%">{{$t('instagram.full_name')}}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(ig, index) in tableDataFollowing" :key="index"  style="page-break-inside: avoid;">
                                                    <td class="text-center">{{index+1}}</td>
                                                    <td class="text-left">{{ig.username}}</td>
                                                    <td class="text-left">{{ig.full_name}}</td>
                                                </tr>
                                            </tbody>
                                            </table>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                </section>
        </vue-html2pdf>
    </simplebar>
    </Layout>
</template>

<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import PreferenceService from "@/helpers/preference.service.js";
import VueWordCloud from 'vuewordcloud'
import GroupService from '@/helpers/group.service'
import InstaService from '@/helpers/osintgram.service'
import SosmedService from '@/helpers/socmed.service'
import moment from 'moment';
import simplebar from "simplebar-vue";
import { ref } from 'vue'



/**
 * Profile component
 */
export default {
  page: {
    title: "Person Of Interest",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, VueWordCloud, simplebar },
   data() {
        let sentimenOptions = {
        series: [],
        chartOptions: {
            chart: {
                type: 'pie',
                height: 100,
                size:250,
                
            },
            labels: [],
            colors: [],
            legend: {
                show: true,
                position: 'bottom',
                labels: {
                colors: '#74788d',
            },
            },
            
            plotOptions: {
                pie: {
                donut: {
                        size: '2%',
                    }
                }
            }
        }
        };
    return {
        items: [
            {
            text: "Home",
            href: "/"
            },
            {
            text: this.$t('instagram.instagram-view'),
            href: "/instagram/"+this.$route.params.id
            },
            {
            text: this.$t('instagram.instagram-view-report'),
            active: true
            }
        ],
        theme: localStorage.getItem('theme'),
        enableDownload: '',
        previewModal: '',
        filename: 'report',
        loadingupdate: false,
        generate: false,
        loading: {
            generate: false,
            print: false
        },
        id: this.$route.params.id,
        avatar: process.env.VUE_APP_BASE_API_URL_OSINT+'stream-profil/?name=',
        title: this.$t('instagram.laporan'),
        sentimenOptions,
        loading:false,
        loadingtag:false,
        loadingfollowers:false,
        loadingfollowing:false,
        loadingupdatetimeline:false,
        loadingupdateusertag:false,
        loadingupdatewordcloud:false,
        loadingsentimen:false,
        loadingsimiliar:false,
        loadingword:false,
        loadingupdateprofile:false,
        loadingheatmap:false,
        cek_heatmap:false,
        elastic:"",
        followers_created_at:"",
        following_created_at:"",
        sentiment_created_at:"",
        timeline_created_at:"",
        similiar_created_at:"",
        wordcloud_created_at:"",
        usertag_created_at:"",
        word_cloud:[],
        wordCloud: [],
        sentiment:[],
        tableData:[],
        tableDataTags:[],
        tableDataSimiliar:[],
        tableDataFollowing:[],
        tableDataFollowers:[],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        currentPageTags: 1,
        perPageTags: 10,
        pageOptions: [10, 25, 50, 100],
        filter: null,
        filterTags:null,
        filterFollowers:null,
        filterFollowing:null,
        filterOn: [],
        sortBy: "age",
        sortDesc: false,
        basicInfo: {
            id : '',
            name : '',
            username : '',
            category_name:'',
            bio : '',
            location : '',
            followers : '',
            following : '',
            media : '',
            join_date : '',
            join_time : '',
            avatar : '',
            updated_at : '',
            is_private:'',
            is_verified:'',
        },
        wordCloud: [],
        hastagsCloud: [],
        heatmapSeries: [
            {
                name: 'Sunday',
                data: [
                    {x: '00:00',y: 0}, 
                    {x: '01:00',y: 0}, 
                    {x: '03:00',y: 0}, 
                    {x: '04:00',y: 0},
                    {x: '05:00',y: 0}, 
                    {x: '06:00',y: 0}, 
                    {x: '07:00',y: 0},
                    {x: '08:00',y: 0}, 
                    {x: '09:00',y: 0}, 
                    {x: '10:00',y: 0},
                    {x: '11:00',y: 0}, 
                    {x: '12:00',y: 0}, 
                    {x: '13:00',y: 0},
                    {x: '14:00',y: 0}, 
                    {x: '15:00',y: 0}, 
                    {x: '16:00',y: 0},
                    {x: '17:00',y: 0}, 
                    {x: '18:00',y: 0}, 
                    {x: '19:00',y: 0},
                    {x: '20:00',y: 0}, 
                    {x: '21:00',y: 0}, 
                    {x: '22:00',y: 0},
                    {x: '23:00',y: 0}, 
                    {x: '24:00',y: 0}
                ]
            },
            {
                name: 'Monday',
                data: [
                    {x: '00:00',y: 0}, 
                    {x: '01:00',y: 0}, 
                    {x: '03:00',y: 0}, 
                    {x: '04:00',y: 0},
                    {x: '05:00',y: 0}, 
                    {x: '06:00',y: 0}, 
                    {x: '07:00',y: 0},
                    {x: '08:00',y: 0}, 
                    {x: '09:00',y: 0}, 
                    {x: '10:00',y: 0},
                    {x: '11:00',y: 0}, 
                    {x: '12:00',y: 0}, 
                    {x: '13:00',y: 0},
                    {x: '14:00',y: 0}, 
                    {x: '15:00',y: 0}, 
                    {x: '16:00',y: 0},
                    {x: '17:00',y: 0}, 
                    {x: '18:00',y: 0}, 
                    {x: '19:00',y: 0},
                    {x: '20:00',y: 0}, 
                    {x: '21:00',y: 0}, 
                    {x: '22:00',y: 0},
                    {x: '23:00',y: 0}, 
                    {x: '24:00',y: 0}
                ]
            },
            {
                name: 'Tuesday',
                data: [
                    {x: '00:00',y: 0}, 
                    {x: '01:00',y: 0}, 
                    {x: '03:00',y: 0}, 
                    {x: '04:00',y: 0},
                    {x: '05:00',y: 0}, 
                    {x: '06:00',y: 0}, 
                    {x: '07:00',y: 0},
                    {x: '08:00',y: 0}, 
                    {x: '09:00',y: 0}, 
                    {x: '10:00',y: 0},
                    {x: '11:00',y: 0}, 
                    {x: '12:00',y: 0}, 
                    {x: '13:00',y: 0},
                    {x: '14:00',y: 0}, 
                    {x: '15:00',y: 0}, 
                    {x: '16:00',y: 0},
                    {x: '17:00',y: 0}, 
                    {x: '18:00',y: 0}, 
                    {x: '19:00',y: 0},
                    {x: '20:00',y: 0}, 
                    {x: '21:00',y: 0}, 
                    {x: '22:00',y: 0},
                    {x: '23:00',y: 0}, 
                    {x: '24:00',y: 0}
                ]
            },
            {
                name: 'Wednesday',
                data: [
                    {x: '00:00',y: 0}, 
                    {x: '01:00',y: 0}, 
                    {x: '03:00',y: 0}, 
                    {x: '04:00',y: 0},
                    {x: '05:00',y: 0}, 
                    {x: '06:00',y: 0}, 
                    {x: '07:00',y: 0},
                    {x: '08:00',y: 0}, 
                    {x: '09:00',y: 0}, 
                    {x: '10:00',y: 0},
                    {x: '11:00',y: 0}, 
                    {x: '12:00',y: 0}, 
                    {x: '13:00',y: 0},
                    {x: '14:00',y: 0}, 
                    {x: '15:00',y: 0}, 
                    {x: '16:00',y: 0},
                    {x: '17:00',y: 0}, 
                    {x: '18:00',y: 0}, 
                    {x: '19:00',y: 0},
                    {x: '20:00',y: 0}, 
                    {x: '21:00',y: 0}, 
                    {x: '22:00',y: 0},
                    {x: '23:00',y: 0}, 
                    {x: '24:00',y: 0}
                ]
            },
            {
                name: 'Thursday',
                data: [
                    {x: '00:00',y: 0}, 
                    {x: '01:00',y: 0}, 
                    {x: '03:00',y: 0}, 
                    {x: '04:00',y: 0},
                    {x: '05:00',y: 0}, 
                    {x: '06:00',y: 0}, 
                    {x: '07:00',y: 0},
                    {x: '08:00',y: 0}, 
                    {x: '09:00',y: 0}, 
                    {x: '10:00',y: 0},
                    {x: '11:00',y: 0}, 
                    {x: '12:00',y: 0}, 
                    {x: '13:00',y: 0},
                    {x: '14:00',y: 0}, 
                    {x: '15:00',y: 0}, 
                    {x: '16:00',y: 0},
                    {x: '17:00',y: 0}, 
                    {x: '18:00',y: 0}, 
                    {x: '19:00',y: 0},
                    {x: '20:00',y: 0}, 
                    {x: '21:00',y: 0}, 
                    {x: '22:00',y: 0},
                    {x: '23:00',y: 0}, 
                    {x: '24:00',y: 0}
                ]
            },
            {
                name: 'Friday',
                data: [
                    {x: '00:00',y: 0}, 
                    {x: '01:00',y: 0}, 
                    {x: '03:00',y: 0}, 
                    {x: '04:00',y: 0},
                    {x: '05:00',y: 0}, 
                    {x: '06:00',y: 0}, 
                    {x: '07:00',y: 0},
                    {x: '08:00',y: 0}, 
                    {x: '09:00',y: 0}, 
                    {x: '10:00',y: 0},
                    {x: '11:00',y: 0}, 
                    {x: '12:00',y: 0}, 
                    {x: '13:00',y: 0},
                    {x: '14:00',y: 0}, 
                    {x: '15:00',y: 0}, 
                    {x: '16:00',y: 0},
                    {x: '17:00',y: 0}, 
                    {x: '18:00',y: 0}, 
                    {x: '19:00',y: 0},
                    {x: '20:00',y: 0}, 
                    {x: '21:00',y: 0}, 
                    {x: '22:00',y: 0},
                    {x: '23:00',y: 0}, 
                    {x: '24:00',y: 0}
                ]
            },
            {
                name: 'Saturday',
                data: [
                    {x: '00:00',y: 0}, 
                    {x: '01:00',y: 0}, 
                    {x: '03:00',y: 0}, 
                    {x: '04:00',y: 0},
                    {x: '05:00',y: 0}, 
                    {x: '06:00',y: 0}, 
                    {x: '07:00',y: 0},
                    {x: '08:00',y: 0}, 
                    {x: '09:00',y: 0}, 
                    {x: '10:00',y: 0},
                    {x: '11:00',y: 0}, 
                    {x: '12:00',y: 0}, 
                    {x: '13:00',y: 0},
                    {x: '14:00',y: 0}, 
                    {x: '15:00',y: 0}, 
                    {x: '16:00',y: 0},
                    {x: '17:00',y: 0}, 
                    {x: '18:00',y: 0}, 
                    {x: '19:00',y: 0},
                    {x: '20:00',y: 0}, 
                    {x: '21:00',y: 0}, 
                    {x: '22:00',y: 0},
                    {x: '23:00',y: 0}, 
                    {x: '24:00',y: 0}
                ]
            }
        ]
    };
  },
   methods:{
    generateReport() {
        console.log('print');
        this.generate = true;
        this.enableDownload = true;
        this.previewModal = false;
        this.filename = 'report instagram analys '+ this.id;
        setTimeout(() => {
            this.generate = false;
            this.$refs.html2Pdf.generatePdf();
        }, 1000);
    },
    getUserBasicInfo(){
        SosmedService.getDetailInstagram(this.id)
        .then(response => {
            this.basicInfo.id = response.data.data.user_id;
            this.basicInfo.name = response.data.data.full_name;
            this.basicInfo.username = response.data.data.account;
            this.basicInfo.bio = response.data.data.bio;
            this.basicInfo.followers = response.data.data.followers;
            this.basicInfo.following = response.data.data.following;
            this.basicInfo.media = response.data.data.media;
            this.basicInfo.is_private = response.data.data.is_private;
            this.basicInfo.is_verified = response.data.data.is_verified;
            this.basicInfo.favorites = response.data.data.favorites;
            this.basicInfo.category_name = response.data.data.category_name;
            this.basicInfo.join_date = response.data.data.join_at;
            this.basicInfo.avatar = response.data.data.picture;
            this.basicInfo.updated_at = response.data.data.updated_at;
        })
        .catch(err => {
            console.log('basic err ->',err);
        });
    },
    getPreferences(){
        PreferenceService.getAllElastic()
        .then((response) => {
            this.elastic = response.data.data[0].ip_address;
            this.getSentimentAnalys();
            this.getWordCloud();
            this.getTimeline();
            this.getUserTag();
            this.getHeatMap();
            this.getSimiliar();
            this.getFollowers();
            this.getFollowing();
        })
        .catch((err) => {
            console.log(err);
        });
    }, 

    getHeatMap(){
        this.loadingheatmap = true;
        InstaService.getHeatMapElastic(this.elastic, this.id)
        .then(response => {
                response.data._source.heatmap.forEach(element => {
                this.cek_heatmap = true;
                this.heatmapSeries.forEach(series => {
                    if(element.day == series.name){
                        series.data.forEach(d => {
                            if (d.x == element.hour+':00') {
                                d.y = element.count
                            }
                        });
                    }
                });
            });
            this.loadingheatmap = false;
        })
        .catch(err => {
            console.log(err);
            this.loadingheatmap = false;
        });
    },
   
    getTimeline(){
        this.loading = true;
        InstaService.getTimelineElastic(this.elastic, this.id)
        .then(response => {
            this.tableData = response.data._source.timeline;
            this.timeline_created_at = response.data._source.created_at;
            this.loading = false;
        })
        .catch(err => {
            if(err == "Error: Request failed with status code 404"){
                  if(!this.basicInfo.is_private){
                    //  this.getTimelineInsta();
                  }
                   console.log(err);
            } else {
                console.log(err);  
                this.loading = true;
            }
        });
    },

    getSimiliar(){
        this.loadingsimiliar = true;
        InstaService.getSimiliarElastic(this.elastic, this.id)
        .then(response => {
            this.similiar_created_at = response.data._source.created_at;
            this.tableDataSimiliar = response.data._source.similiar;
            this.loadingsimiliar = false;
        })
        .catch(err => {
        console.log(err);  
        this.loadingsimiliar = false;
        })
    },

    getFollowers(){
        this.loadingfollowers = true;
        InstaService.getFollowersElastic(this.elastic, this.id)
        .then(response => {
            this.followers_created_at = response.data._source.created_at;
            this.tableDataFollowers = response.data._source.followers;
            this.loadingfollowers = false;
        })
        .catch(err => {
        console.log(err);  
        this.loadingfollowers = false;
        })
    },

      getFollowing(){
        this.loadingfollowing = true;
        InstaService.getFollowingElastic(this.elastic, this.id)
        .then(response => {
            this.following_created_at = response.data._source.created_at;
            this.tableDataFollowing = response.data._source.following;
            this.loadingfollowing = false;
        })
        .catch(err => {
        console.log(err);  
        this.loadingfollowers = false;
        })
    },
 
 
 
    getUserTag(){
        this.loadingtag = true;
        InstaService.getUserTagsElastic(this.elastic, this.id)
        .then(response => {
            this.usertag_created_at = response.data._source.created_at;
            this.tableDataTags = response.data._source.usertag.slice(0, 24);
            this.loadingtag = false;
        })
        .catch(err => {
            if(err == "Error: Request failed with status code 404"){
                 if(!this.basicInfo.is_private){
                    // this.getUserTagInsta();
                  }
            } else {
                console.log(err);  
                this.loadingtag = true;
            }
        });
    },
  
    getWordCloud(){
        this.loading = true;
        InstaService.getWordcloudElastic(this.elastic, this.id)
         .then(response => {      
            this.wordcloud_created_at = response.data._source.created_at;
            response.data._source.wordcloud.forEach((element, i) => {
                this.wordCloud.push([element.word, element.count])
                this.loadingword = false;
            });
        })
        .catch(err => {
            if(err == "Error: Request failed with status code 404"){
                  if(!this.basicInfo.is_private){
                    // this.getWordCloudIG();
                  }
            } else {
                console.log(err);  
                this.loading = true;
            }
        });
    },

    getSentimentAnalys(){
        this.loadingsentimen = true,
        InstaService.getSentimentElastic(this.elastic, this.id)
        .then(response => {
            this.sentiment_created_at = response.data._source.created_at;
            response.data._source.sentiment.forEach(event => {
            this.sentimenOptions.chartOptions.labels.push(event.sentiment)
            this.sentimenOptions.chartOptions.colors.push(event.color)
            this.sentimenOptions.series.push(event.count) 
            this.loadingsentimen = false;
        });
        })
        .catch(err => {
             if(err == "Error: Request failed with status code 404"){
                  if(!this.basicInfo.is_private){
                        // this.getSentimentAnalysIG();
                  }
                  this.loadingsentimen = false;
            } else {
                console.log(err);  
                this.loading = true;
            }
        });
    },
  
    formatDate(value){
      return moment(value).format("YYYY-MM-DD, hh:mm");
    },
    formatDateRefresh(value){
      return moment(value).format("YYYY-MM-DD, hh:mm");
    },
    formatDay(value){
      let timestamp = { seconds: value, nanoseconds: 0 } // firebase data     
      let myDate = new Date(timestamp.seconds * 1000) // date object
      return myDate;
    },
     formatDay(value){
      return moment(value).format("dddd");
    },
    toFixed(value){
      return value.toFixed(0);
    },
    },
    beforeMount(){
         this.getUserBasicInfo();
         this.getPreferences();
    },
    mounted(){
        // this.getSentimentAnalys();
        // this.getWordCloud();
        // this.getTimeline();
        // this.getUserTag();
    }
};
</script>

<style scoped>
/* .card{
  border: 2px solid #f1f1f1;
} */
.my-custom-scrollbar {
position: relative;
height: 500px;
overflow: auto;
}
.table-wrapper-scroll-y {
display: block;
}
</style>